<template>
  <div class="service-container">
    <div class="service-container-1">
      <div class="service-title-1">
        <p class="service-title-font">
          Service <span style="color: #d5d5d5">1/3</span>
        </p>
        <p
          class="service-content-font"
          v-html="$t('service.service1.title')"
        ></p>
      </div>

      <hr style="background: #a0a0a0" />
      <div class="service-slider-1"></div>
      <hr style="background: #a0a0a0" />

      <div class="service-strategy-container">
        <div class="service-strategy">
          <div class="strategy-1">
            <p class="strategy-title">
              {{ $t("service.service1.sections.section1.title") }}
            </p>
            <div class="strategy-img strategy-img-1"></div>
            <div class="strategy-img strategy-square-background"></div>
            <div class="strategy-content">
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section1.content1") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section1.content2") }}
              </p>
            </div>
          </div>
          <div class="strategy-2">
            <p class="strategy-title">
              {{ $t("service.service1.sections.section2.title") }}
            </p>
            <div class="strategy-img strategy-img-2"></div>
            <div class="strategy-img strategy-square-background"></div>
            <div class="strategy-content">
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section2.content1") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section2.content2") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section2.content3") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section2.content4") }}
              </p>
            </div>
          </div>
          <div class="strategy-3">
            <p class="strategy-title">
              {{ $t("service.service1.sections.section3.title") }}
            </p>
            <div class="strategy-img strategy-img-3"></div>
            <div class="strategy-img strategy-square-background"></div>
            <div class="strategy-content">
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section3.content1") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section3.content2") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section3.content3") }}
              </p>
              <p class="p-defeasance">
                {{ $t("service.service1.sections.section3.content4") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="service-container-2">
      <div class="service-title-1">
        <p class="service-title-font">
          Service <span style="color: #d5d5d5">2/3</span>
        </p>
        <p
          class="service-content-font"
          v-html="$t('service.service2.title')"
        ></p>
      </div>

      <div class="service-slider-2"></div>

      <div class="service-product-container">
        <p
          class="service-product-title"
          v-html="$t('service.service2.content')"
        ></p>
        <div class="service-products">
          <div class="service-product-img service-product-img-1">
            <div class="service-product-box">
              <div class="service-product-content-box">
                <img src="@/assets/icons/product-icon-1.png" class="product-icon">
                <span class="product-icon-content" v-html="$t('service.service2.pictures.content1')"></span>
              </div>
            </div>
          </div>
          <div class="service-product-img service-product-img-2">
            <div class="service-product-box">
              <div class="service-product-content-box">
                <img src="@/assets/icons/product-icon-2.png" class="product-icon">
                <span class="product-icon-content" v-html="$t('service.service2.pictures.content2')"></span>
              </div>
            </div>
          </div>
          <div class="service-product-img service-product-img-3">
            <div class="service-product-box">
              <div class="service-product-content-box">
                <img src="@/assets/icons/product-icon-3.png" class="product-icon">
                <span class="product-icon-content" v-html="$t('service.service2.pictures.content3')"></span>
              </div>
            </div>
          </div>
          <div class="service-product-img service-product-img-4">
            <div class="service-product-box">
              <div class="service-product-content-box">
                <img src="@/assets/icons/product-icon-4.png" class="product-icon">
                <span class="product-icon-content" v-html="$t('service.service2.pictures.content4')"></span>
              </div>
            </div>
          </div>
          <div class="service-product-img service-product-img-5">
            <div class="service-product-box">
              <div class="service-product-content-box">
                <img src="@/assets/icons/product-icon-5.png" class="product-icon">
                <span class="product-icon-content" v-html="$t('service.service2.pictures.content5')"></span>
              </div>
            </div>
          </div>
          <div class="service-product-img service-product-img-6"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Service',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/service.css"></style>
<style scoped src="@/assets/styles/service-mobile.css"></style>



// WEBPACK FOOTER //
// src/components/renewal/components/Service.vue